<template>
    <div :class="styleMain">
      <el-time-picker size="small" :value="display" placeholder="" :clearable="false" @input="change" @change="update" />
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionTime',
  props: {
    action: Object
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    display () { return this.value || this.action.date },

    styleMain () { return ['sportFootballMatchActionTime', this.action.homeAway] }
  },
  methods: {
    change (value) { this.value = value },
    update (value) {
      this.value = null
      const dateNew = new Date(value)
      const date = this.action.date
      date.setHours(dateNew.getHours())
      date.setMinutes(dateNew.getMinutes())
      date.setSeconds(dateNew.getSeconds())
      this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, date: date })
    }
  }
}
</script>

<style>
.sportFootballMatchActionTime {
  grid-area: time;
}
.sportFootballMatchActionTime .el-date-editor.el-input{
  width: 100%
}
.sportFootballMatchActionTime .el-input input{
  height:22px;
  font-size:10px;
  border-radius:16px;
  padding:0 4px;
  text-align: center;
}
.sportFootballMatchActionTime .el-input--small .el-input__icon {
    display:none;
    line-height: 22px;
    font-size: 10px
}
.sportFootballMatchActionTime.home .el-input.is-active .el-input__inner,
.sportFootballMatchActionTime.home .el-input__inner:focus{
  border-color:var(--color-team-home)
}
.sportFootballMatchActionTime.away .el-input.is-active .el-input__inner,
.sportFootballMatchActionTime.away .el-input__inner:focus{
  border-color:var(--color-team-away)
}
</style>
